import { Box, Theme, useMediaQuery, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useLocation } from "react-router-dom";
import { BodyBg, Logo } from "../../Assets";
import T20Logo from "../../Assets/logo/t20.svg";
import { ReactChildren } from "../../interfaces/Common";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import routes from "../../Utils/routes";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100dvh",
    width: "100%",
    position: "relative",
    backgroundColor: "#000000",
    backgroundImage: `url(${BodyBg}) !important`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    fontFamily: "Schibsted Grotesk !important",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  desktopContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: "#000000",
    backgroundImage: `url(${BodyBg}) !important`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    transition: "opacity 1s ease-in-out",
    zIndex: 10,
    overflow: "hidden",
  },
  navbar: {
    position: "relative",
    zIndex: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    minHeight: "72px",
    padding: "14px 100px",
    background: "#070707",
    borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      minHeight: "60px",
      padding: "10px 24px",
    },
  },
  primaryLogoWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "60px",
    height: "60px",
    borderRadius: "999px",
    background: "#FFFFFF",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.18)",
    [theme.breakpoints.down("md")]: {
      width: "42px",
      height: "42px",
    },
  },
  primaryLogo: {
    display: "block",
    width: "76%",
    height: "76%",
    objectFit: "contain",
  },
  secondaryLogo: {
    display: "block",
    width: "52px",
    height: "40px",
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      width: "44px",
      height: "34px",
    },
  },
  mobileScreen: {
    flex: 1,
    position: "relative",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  desktopContent: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  desktopScreen: {
    height: "100%",
    minHeight: 0,
    width: "calc(60% - 80px)",
    maxWidth: "520px",
    maxHeight: "820px",
    position: "relative",
    background: "black",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  desktopScreenLauncher: {
    maxHeight: "none",
    background: "transparent",
    overflow: "visible",
  },
  formContainer: {
    position: "fixed",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100% !important",
    minHeight: "100vh !important",
    width: "100% !important",
    alignItems: "center",
  },
  copywrite: {
    fontSize: "14px !important",
    fontWeight: "500",
    color: "#8A8A8A",
    [theme.breakpoints.down("ultraHD")]: {
      fontSize: "10.5px !important",
    },
  },
  loginVector: {
    height: "330px",
    opacity: "0.1",
    [theme.breakpoints.down("md")]: {
      height: "230px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "130px",
    },
  },
  logo: {
    position: "absolute",
    top: "52%",
    [theme.breakpoints.down("ultraHD")]: { top: "42%" },
    left: "-7%",
    opacity: "10%",
    width: "661px",
    height: "661px",
    zIndex: 1,
  },
}));

const AuthLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // useEffect(() => {
  //   navigate(routes.closed);
  // }, []);
  const location = useLocation();
  const isLauncherRoute = location.pathname === routes.launcher;

  return (
    <>
      {isMobile ? (
        <Box className={classes.container}>
          <Box className={classes.navbar}>
            <Box className={classes.primaryLogoWrap}>
              <img
                src={Logo}
                alt="Mumbai Cricket Association"
                className={classes.primaryLogo}
              />
            </Box>
            <img
              src={T20Logo}
              alt="T20 Mumbai"
              className={classes.secondaryLogo}
            />
          </Box>
          <Box className={classes.mobileScreen}>{children}</Box>
        </Box>
      ) : (
        <Box className={classes.desktopContainer}>
          <Box className={classes.navbar}>
            <Box className={classes.primaryLogoWrap}>
              <img
                src={Logo}
                alt="Mumbai Cricket Association"
                className={classes.primaryLogo}
              />
            </Box>
            <img
              src={T20Logo}
              alt="T20 Mumbai"
              className={classes.secondaryLogo}
            />
          </Box>
          <Box className={classes.desktopContent}>
            <Box
              className={`${classes.desktopScreen} ${
                isLauncherRoute ? classes.desktopScreenLauncher : ""
              }`}
            >
              {children}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default AuthLayout;
